module.exports = __webpack_public_path__ + "static/BundesSans-Web-RegularItalic-6cc4930b097dc7985a4868edbad78c61.woff";